import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "query", "toggler"];

  connect() {
    if (!this.hasTogglerTarget || !this.hasFormTarget) {
      console.error("Missing form or toggler target for form-search controller.");
    }

    // Add a keydown listener to the document to handle "Escape" globally
    document.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  disconnect() {
    // Clean up the keydown listener when the controller disconnects
    document.removeEventListener("keydown", this.handleKeydown.bind(this));
  }

  toggleSearch() {
    if (this.formTarget.classList.contains("active")) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  openSearch() {
    this.formTarget.classList.add("active");
    this.queryTarget.classList.add('open')
  }

  closeSearch() {
    this.queryTarget.classList.remove('open')
    setTimeout(() => {
      this.formTarget.classList.remove("active");
    }, 200)
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.formTarget.classList.contains("active")) {
      this.closeSearch();
    }
  }
}
